import { Dispatch } from 'react';
import { createContext } from 'use-context-selector';
import { InternationalizationState, InternationalizationAction } from './types';

const InternationalizationContext = createContext<InternationalizationState>({} as InternationalizationState);
const InternationalizationDispatchContext = createContext<Dispatch<InternationalizationAction> | undefined>(undefined);

export { InternationalizationContext, InternationalizationDispatchContext };
